import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormChangesDirective } from './formChanges';
import { FormValidationDirective } from './form-validation';
import { ReactiveFormsModule } from '@angular/forms';
import * as fromErrors from './errors';

@NgModule({
  imports: [CommonModule, ReactiveFormsModule],
  declarations: [
    FormChangesDirective,
    FormValidationDirective,
    ...fromErrors.COMPONENTS,
    ...fromErrors.DIRECTIVES
  ],
  entryComponents: [...fromErrors.ENTRY_COMPONENTS],
  exports: [
    ReactiveFormsModule,
    FormChangesDirective,
    FormValidationDirective,
    ...fromErrors.COMPONENTS,
    ...fromErrors.DIRECTIVES
  ]
})
export class ApFormsModule { }
